import { Job, JobStatus } from './types'

export function isJobFinished(job: Job<unknown, unknown>) {
  return [
    JobStatus.COMPLETED,
    JobStatus.CANCELLED,
    JobStatus.FAILED,
  ].includes(job.status)
}

export function isJobWaiting(job: Job) {
  return [JobStatus.PENDING, JobStatus.PROCESSING].includes(
    job.status
  )
}
